import React from 'react';
import {fetchContentPage} from '../../util/pages';
import {useRouter} from 'next/router';
import SeoTags from '../../components/SeoTags';
import wrapper from '../../store/store';
import {withUserGetServerSideProps} from '../../util/util';
import {useAuth} from '../../util/auth';

function ContentPage(props) {
    const router = useRouter();


    return <CmsContent {...props} id={router.query.slug} />;
}

export const getServerSideProps = wrapper.getServerSideProps(withUserGetServerSideProps(async (ctx) => {
    const content = await fetchContentPage(ctx.params.slug);
    return { props: {content} }
}));

type CmsContentProps = {
    content?: {
        seo?: {
            config: {
                title: string;
                description: string;
                keywords: string;
            }
        }
        layout?: {
            wysiwyg: string;
        }[]
    };
}

const CmsContent = (props: CmsContentProps) => {
    const auth = useAuth();
    if (!props?.content?.layout?.length) {
        return null;
    }

    return (
        <>
            <SeoTags config={props.content.seo} />

            <div className="container">
                <div className="prose m-auto">
                    {(props.content.layout || []).map((it, index) => {
                        if (!it.wysiwyg) {
                            return null;
                        }
                        return (
                            <div key={index} dangerouslySetInnerHTML={{
                                __html: it.wysiwyg
                            }}/>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default ContentPage;
